(function () {
  const allPageLinks = document.querySelectorAll("#pills-page a");
  const allPostLinks = document.querySelectorAll("#pills-post a");

  const insetPath = (links) => {
    for (const link of links) {
      const path = link.getAttribute("href");
      const pathElm = document.createElement("span");

      pathElm.classList.add("path-name");
      pathElm.textContent = "/" + path.split("/").pop();
      link.appendChild(pathElm);
    }
  }

  insetPath(allPostLinks);
  insetPath(allPageLinks);

  for (const link of allPageLinks) {
    if (link.nextElementSibling) {
      const toggleElm = document.createElement("span");
      const srOnlyElm = document.createElement("span");
      toggleElm.classList.add("toggle");
      srOnlyElm.classList.add("sr-only");
      srOnlyElm.textContent = "Toggle";
      toggleElm.appendChild(srOnlyElm);
      link.appendChild(toggleElm);

      link.addEventListener("click", (event) => {
        if (event.target === toggleElm) {
          link.setAttribute(
            "aria-expanded",
            link.getAttribute("aria-expanded") !== "true" ? "true" : "false"
          );
          event.preventDefault();
        }
      });
    }
  }
})();
